import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloudOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCloudOff"><Path d="M8.40946 5.58085C9.43821 4.89787 10.6726 4.5 12 4.5C15.4303 4.5 18.24 7.15724 18.483 10.5256C20.7411 10.7666 22.5 12.6779 22.5 15C22.5 16.2862 21.9604 17.4464 21.0951 18.2665M2.75 2.75L21.25 21.25M6.7455 7.17298C6.42661 7.61006 6.16094 8.08843 5.95801 8.59857C3.4187 9.08552 1.5 11.3187 1.5 14C1.5 17.0376 3.96243 19.5 7 19.5H18C18.3437 19.5 18.6784 19.4615 19 19.3885" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCloudOff;
